import { Modal, Upload, Button, message } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
const { Dragger } = Upload;

const ImportFileModal = ({ open, onClose, handleUpload, handleDownloadCSVTemplate }) => {
  const [fileList, setFileList] = useState([]);

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".csv,.xlsx,.xls",
    fileList,
    beforeUpload: (file) => {
      setFileList([file]);
      return false; // prevent auto upload
    },
    onRemove: () => setFileList([]),
  };

  const handleUploadFile = () => {
    if (fileList.length === 0) {
      message.warning("Please select a file first.");
      return;
    }
    // const formData = new FormData();
    // formData.append("file", fileList[0]);
    handleUpload(fileList[0]);
    // your API call here
    setFileList([]);
    onClose();
  };

  return (
    <Modal
      title="Import File"
      open={open}
      onCancel={() => { setFileList([]); onClose(); }}
      footer={
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Button
            icon={<DownloadOutlined />}
            onClick={handleDownloadCSVTemplate}
            style={{
              backgroundColor: "#2C963D",
              color: "#fff",
              border: "none",
              borderRadius: "20px",
            }}
          >
            Download Template
          </Button>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => { setFileList([]); onClose(); }}
              style={{ borderRadius: "20px" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={fileList.length === 0}
              onClick={handleUploadFile}
              style={{
                backgroundColor: "#2C963D",
                border: "none",
                borderRadius: "20px",
              }}
            >
              Upload
            </Button>
          </div>
        </div>
      }
      width={620}
    >
      <Dragger {...uploadProps} style={{ borderRadius: "8px", padding: "20px", marginBottom: "10px" }}>
        <p className="ant-upload-drag-icon">
         <UploadOutlined style={{ color: "#5F6D8C" }} />
        </p>
        <p className="ant-upload-text" style={{ color:"#5F6D8C"}}>
          <strong>Drag and Drop</strong> or{" "}
          <span style={{ color: "#2C963D" }}>Choose file</span>
          <span> to upload</span>
        </p>
      </Dragger>
    </Modal>
  );
};

export default ImportFileModal;